<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  deal: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['click']);

const { t } = useI18n();

const formattedAmount = computed(() => {
  if (!props.deal.amount) return '-';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(props.deal.amount);
});

const contactName = computed(
  () => props.deal.contact?.name || t('DEALS.UNASSIGNED_CONTACT')
);

const handleClick = () => emit('click', props.deal);
</script>

<template>
  <div
    class="flex flex-col gap-1 p-3 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm cursor-pointer hover:border-woot-500 hover:shadow-md transition-all duration-150"
    @click="handleClick"
  >
    <span
      class="text-sm font-medium text-slate-900 dark:text-slate-100 truncate"
    >
      {{ deal.name }}
    </span>
    <span class="text-sm font-semibold text-woot-600 dark:text-woot-400">
      {{ formattedAmount }}
    </span>
    <span class="text-xs text-slate-500 dark:text-slate-400 truncate">
      {{ contactName }}
    </span>
  </div>
</template>
